import { render, staticRenderFns } from "./HistoryView.vue?vue&type=template&id=36da5cd7&scoped=true&"
import script from "./HistoryView.vue?vue&type=script&lang=js&"
export * from "./HistoryView.vue?vue&type=script&lang=js&"
import style0 from "./HistoryView.vue?vue&type=style&index=0&id=36da5cd7&prod&lang=scss&scoped=true&"
import style1 from "./HistoryView.vue?vue&type=style&index=1&id=36da5cd7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36da5cd7",
  null
  
)

export default component.exports